<script setup lang="ts">
const { te } = useI18n()

const contacts = [1, 2, 3] // max 3 contact branches
const langContact = 'aboutCompany.contacts.contact-'
const langContacts = contacts.filter((contactId) =>
  te(langContact + contactId.toString() + '.title')
)
</script>

<template>
  <section class="pb-8">
    <div v-for="(contactId, index) in langContacts" :key="index">
      <div>
        <div class="flex flex-wrap">
          <ContactBranch
            class="w-full lg:w-1/2"
            :class="{
              'lg:order-2': contactId % 2 == 0,
            }"
            :lang-path="langContact + contactId.toString()"
          />
          <ContactGoogleMap
            class="min-h-[450px] w-full lg:w-1/2"
            :map-url="$t(langContact + contactId.toString() + '.map-url')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
